<template>
  <div>
    <div class="page-hero">
      <div class="container">
        <span class="section__label">Контакты</span>
        <h1 class="page-hero__title">Свяжитесь с нами</h1>
        <p class="page-hero__text">Ответим на любой вопрос в течение одного рабочего дня</p>
      </div>
    </div>

    <section class="section">
      <div class="container contacts-layout">
        <div>
          <form class="contact-form" @submit.prevent="submit">
            <h2 class="contact-form__title">Напишите нам</h2>
            <input v-model="form.website" type="text" name="website" tabindex="-1" autocomplete="off" class="hp-field" />
            <div class="form-group">
              <label>Имя *</label>
              <input v-model="form.name" type="text" placeholder="Ваше имя" required />
            </div>
            <div class="form-group">
              <label>Email *</label>
              <input v-model="form.email" type="email" placeholder="email@company.ru" required />
            </div>
            <div class="form-group">
              <label>Тема</label>
              <select v-model="form.subject">
                <option value="">Выберите тему</option>
                <option>Вопрос о продукте</option>
                <option>Техническая поддержка</option>
                <option>Партнёрство</option>
                <option>Другое</option>
              </select>
            </div>
            <div class="form-group">
              <label>Сообщение *</label>
              <textarea v-model="form.message" rows="5" placeholder="Ваш вопрос или сообщение..." required />
            </div>
            <base-button size="lg" style="width:100%; justify-content:center;" :disabled="sending || sent">
              {{ sent ? 'Сообщение отправлено ✓' : (sending ? 'Отправляем…' : 'Отправить') }}
            </base-button>
            <p v-if="error" class="contact-form__error">{{ error }}</p>
            <p v-if="sent" class="contact-form__success">Спасибо! Мы ответим в течение рабочего дня.</p>
            <p class="contact-form__note">
              Нажимая «Отправить», вы соглашаетесь с
              <router-link to="/policy">политикой конфиденциальности</router-link>.
            </p>
          </form>
        </div>

        <div class="contact-info">
          <h3 class="contact-info__title">Контактная информация</h3>
          <div class="contact-info__items">
            <div class="contact-info__item">
              <span class="contact-info__icon"><ui-icon name="phone" :size="22" /></span>
              <div>
                <div class="contact-info__label">Телефон</div>
                <a href="tel:+79939037308">+7 993 903-73-08</a>
              </div>
            </div>
            <div class="contact-info__item">
              <span class="contact-info__icon"><ui-icon name="mail" :size="22" /></span>
              <div>
                <div class="contact-info__label">Email</div>
                <a href="mailto:info@candb.pro">info@candb.pro</a>
              </div>
            </div>
            <div class="contact-info__item">
              <span class="contact-info__icon"><ui-icon name="clock" :size="22" /></span>
              <div>
                <div class="contact-info__label">Режим работы</div>
                <span>Пн–Пт, 9:00–18:00 МСК</span>
              </div>
            </div>
          </div>

          <div class="contact-info__demo">
            <p>Хотите увидеть продукт?</p>
            <base-button to="/demo" variant="outline" size="md">Запросить демо</base-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseButton from '../components/ui/BaseButton.vue'
import UiIcon from '../components/ui/UiIcon.vue'
export default {
  name: 'ContactsPage',
  components: { BaseButton, UiIcon },
  data() {
    return {
      sent: false,
      sending: false,
      error: '',
      form: { name: '', email: '', subject: '', message: '', website: '' },
    }
  },
  methods: {
    async submit() {
      this.error = ''
      this.sending = true
      try {
        const apiBase = process.env.VUE_APP_API_BASE || 'https://app.candb.pro/'
        const res = await fetch(apiBase.replace(/\/?$/, '/') + 'core/api/leads/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...this.form, source: 'contacts' }),
        })
        if (res.status === 202 || res.ok) {
          this.sent = true
        } else {
          let body = {}
          try { body = await res.json() } catch (e) {}
          this.error = body.detail || 'Не удалось отправить сообщение. Напишите на info@candb.pro.'
        }
      } catch (e) {
        this.error = 'Сеть недоступна. Напишите на info@candb.pro.'
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.page-hero {
  background: linear-gradient(135deg, #1E3A8A, #2563EB);
  color: white;
  padding: 140px 0 80px;
}
.page-hero__title { font-size: 2.5rem; font-weight: 800; margin: 12px 0 16px; }
.page-hero__text { font-size: 1.125rem; opacity: 0.85; }

.contacts-layout { display: grid; grid-template-columns: 1fr 380px; gap: 64px; }
.contact-form__title { font-size: 1.5rem; font-weight: 700; margin-bottom: 28px; }
.contact-form { display: flex; flex-direction: column; gap: 20px; }
.form-group { display: flex; flex-direction: column; gap: 6px; }
.form-group label { font-size: 0.875rem; font-weight: 600; color: var(--dark); }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.9375rem;
  font-family: inherit;
  color: var(--dark);
  background: white;
  transition: var(--transition);
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
}
.contact-form__note { font-size: 0.8125rem; color: var(--gray); text-align: center; }
.contact-form__note a { color: var(--primary); text-decoration: none; }
.contact-form__note a:hover { text-decoration: underline; }
.contact-form__error {
  background: #FEF2F2; border: 1px solid #FECACA; color: #B91C1C;
  padding: 10px 14px; border-radius: var(--radius-sm); font-size: 0.9375rem;
}
.contact-form__success {
  background: #ECFDF5; border: 1px solid #A7F3D0; color: #065F46;
  padding: 12px 14px; border-radius: var(--radius-sm); font-size: 0.9375rem;
}
.hp-field { position: absolute !important; left: -9999px !important; width: 1px !important; height: 1px !important; opacity: 0; }

.contact-info {
  background: var(--light);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 36px 32px;
  position: sticky;
  top: 100px;
}
.contact-info__title { font-size: 1.25rem; font-weight: 700; margin-bottom: 28px; }
.contact-info__items { display: flex; flex-direction: column; gap: 24px; margin-bottom: 36px; }
.contact-info__item { display: flex; gap: 16px; align-items: flex-start; }
.contact-info__icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 38px; height: 38px;
  border-radius: 10px;
  background: var(--primary-light); color: var(--primary);
  flex-shrink: 0;
}
.contact-info__label { font-size: 0.8125rem; color: var(--gray); font-weight: 600; margin-bottom: 4px; }
.contact-info__item a,
.contact-info__item span { font-size: 0.9375rem; color: var(--dark); }
.contact-info__item a { color: var(--primary); }
.contact-info__demo p { font-size: 0.9375rem; color: var(--gray); margin-bottom: 14px; }

@media (max-width: 900px) {
  .contacts-layout { grid-template-columns: 1fr; }
  .contact-info { position: static; }
  .page-hero__title { font-size: 1.875rem; }
}
</style>
